import { Popover, PopoverProps } from '@pypestream/design-system';
import { FC, PropsWithChildren } from 'react';

export interface GenericPopoverProps {
  width?: 'default' | 'auto';
  trigger: string;
  popoverRef: React.RefObject<PopoverProps> | null;
  onClose?: () => void;
  testId?: string;
}

export const GenericPopover: FC<PropsWithChildren<GenericPopoverProps>> = ({
  width = 'default',
  trigger,
  popoverRef,
  testId,
  children,
}) => {
  return (
    <Popover width={width} trigger={trigger} ref={popoverRef} test-id={testId}>
      {children}
    </Popover>
  );
};
